import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import './DeleteModal.css';

const SendBulletinNotiModal = ({ handleClose, show, bulletin, onPushNoti }) => {
    const showHideClassName = show
        ? 'delete-modal display-block'
        : 'delete-modal display-none';
        
    const [notification, setNotification] = useState('');
    
    useEffect(() => {
        if (bulletin.employee.indexOf(',') > -1) {
            let array = bulletin.employee.split(',')

            for (let i = 0; i < array.length; i++) {
                let mappedArray = array.map((item) => ({
                    id: bulletin.bbID,
                    title: bulletin.title,
                    employee: item.toLowerCase().replaceAll(' ', ''),
                }));

                setNotification(mappedArray)
            }
        } else {
            let mappedString = [{ id: bulletin.bbID, title: bulletin.title, employee: bulletin.employee}]

            setNotification(mappedString)
        }

    }, [bulletin]);

    const sendNotification = () =>  {
        onPushNoti({
            notification
        });
    }

    return (
        <div className={showHideClassName}>
            <section className='delete-modal-main'>
                <Row>
                    <Col>
                        <h4 className='noti-modal-title'>Send Notification?</h4>
                        <p>Send notification for this bulletin?</p>
                        <Button variant='primary' onClick={sendNotification}>Send Notification</Button>
                        <Button variant='outline-primary' onClick={handleClose} style={{borderColor:'white'}}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </section>
        </div>
    );
};

export default SendBulletinNotiModal;
